<template>
  <div>
    <div class="d-flex justify-center" v-if="isLoading">
      <v-progress-circular size="50" color="blue" indeterminate/>
    </div>
    <div v-else>
      <div class="d-flex">
        <h2 class="titleText--text">Synergy parameters</h2>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon  v-bind="attrs" size="medium"
            v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
          </template>
          <span> Synergy parameters</span>
        </v-tooltip>
      </div>
      <v-card flat class="custom-shadow mb-5 mt-2">
        <v-card-text class="d-flex justify-space-between">
          <div class="d-flex justify-space-between align-center">
            <div style="width: 100%">
              <v-select
                multiple
                v-model="synergy_input_list_selected"
                :items="synergy_input_list"
                hide-details="auto"
                placeholder="Select variables"
                background-color="#f3f5f8"
                solo
                style="border-radius: 8px"
                flat
              >
              <template v-slot:prepend-item>
                <v-text-field 
                  v-model="searchTerm"
                  placeholder="Search"
                  @input="searchItems"
                  hide-details
                  dense
                  clearable
                  flat
                  solo
                  solo-filled
                  prepend-inner-icon="mdi-magnify"
                />
              </template>
                <template v-slot:selection="{ item }">
                  <v-chip close  small dark color="blue" class="font-weight-bold" @click:close="removeVariable(item)">{{
                    item
                  }}</v-chip>
                </template>
              </v-select>
            </div>
          </div>
          <div class="d-flex align-center">
            <v-btn
              title="Run the Model"
              right
              depressed
              class="ml-3"
              height="42"
              dark
              color="blue"
              :loading="!synergy_input_list.length"
              @click="OnclickSaveAndEdit()"
            >
              <v-icon color="white" class="ml-0 mr-3" right dark>
                mdi-chart-waterfall
              </v-icon>
              <span class="font-weight-bold text-capitalize white--text"
                >Calculate Synergy</span
              >
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <v-card flat class="custom-shadow mb-5" v-if="isnation !=0">
        <v-card-title></v-card-title>
        <v-card-text class="align-right">
          <v-spacer></v-spacer>
          <div style="width: 300px" class="align-right">
            <v-select
              v-model="dataregionSelected"
              :items="listofregion"
              hide-details="auto"
              placeholder="Select Region"
              background-color="#f3f5f8"
              solo
              flat
              class="custom-shadow"
            >
              <template v-slot:selection="{ item }">
                <v-chip small dark color="blue" class="font-weight-bold">{{
                  item
                }}</v-chip>
              </template>
            </v-select>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-row>
      <v-col cols="12" class="d-flex justify-start">
        <v-btn-toggle mandatory borderless color="blue">
          <v-btn height="36" small exact @click="isDiagram = true; drawSankeyDiagram()">
            <span class="text-capitalize font-weight-bold titleText--text"
              >Sankey Diagram</span
            >
          </v-btn>
          <v-btn height="36" small exact @click="isDiagram = false">
            <span class="text-capitalize font-weight-bold titleText--text"
              >Table View</span
            >
          </v-btn>
        </v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <v-card flat class="custom-shadow">
            <v-card-text v-if="!synergy_input_list.length && !searchTerm"  class="d-flex justify-center align-center" style="height: 100%">
              <v-progress-circular
                indeterminate
                color="blue"
                size="50"
                class="d-flex justify-self-center align-self-center"
              ></v-progress-circular>
            </v-card-text>
          <div class="d-flex justify-center align-center font-weight-bold titleText--text" style="height: 100%" v-if="!Object.keys(listofsynergy_between_variables_data.synergy).length">
            <p>Not found synergy between selected variables</p>
          </div>
          <div v-show="Object.keys(listofsynergy_between_variables_data.synergy).length">
            <div v-if="isDiagram && synergy_input_list.length" style="width: 100%; max-height: 500px; background: white;" ref="sankey" class="custom-shadow pb-8"></div>
            <v-simple-table v-if="!isDiagram" fixed-header style="overflow: auto;">
            <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left font-weight-bold" style="background: #f1f1f1">
                      Name
                    </th>
                    <th class="text-center font-weight-bold" style="background: #f1f1f1">
                      Synergy
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, name) in listofsynergy_between_variables_data.synergy"
                    :key="name"
                  >
                    <td class="text-left titleText--text">{{ name }}</td>
                    <td class="text-center titleText--text">{{ item.synergy_per }} %</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
      
  </div>
</template>
<script>
import apifactory from "../../api";
import globalstorageapi from "../../../../global/GlobalStrorage";
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5flow from "@amcharts/amcharts5/flow";
export default {
  setup() {},
  data: () => ({
    listofsynergy_between_variables_data: null,
    synergy_input_list: [],
    synergy_input_list_selected: [],
    itemlistofsavedParamameters: [],
    savedid: 0,
    projectid: globalstorageapi.getProjectID(),
    listofregion: [],
    dataregionSelected: null,
    isnation: 0,
    isDiagram: true,
    isLoading: true,
    searchTerm: '',
    copiedItems: [],
    mappedData: [],
    resetSankey: false
  }),
  methods: {
    removeVariable(variable) {
      this.synergy_input_list_selected =
        this.synergy_input_list_selected.filter((item) => item !== variable);
    },
    searchItems() {
      if (!this.searchTerm) {
        this.synergy_input_list = [...this.copiedItems]
      }

      this.synergy_input_list = this.copiedItems.filter((item) => {
        return item.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    drawSankeyDiagram () {
      this.$nextTick(() => {

        if (this.$refs.sankey) {
          let root = am5.Root.new(this.$refs.sankey)
          root.setThemes([am5themes_Animated.new(root)])
    
          let series = root.container.children.push(am5flow.Sankey.new(root, {
            sourceIdField: "from",
            targetIdField: "to",
            valueField: "value",
            paddingRight: 200,
            nodePadding: 20,
            nodeAlign: "justify"
          }))
    
          series.nodes.get("colors").set("step", 3)
    
          this.mappedData = []
    
          for (let item in this.listofsynergy_between_variables_data.synergy) {
            this.mappedData.push({ from: this.listofsynergy_between_variables_data.synergy[item].from, to: this.listofsynergy_between_variables_data.synergy[item].to, value: this.listofsynergy_between_variables_data.synergy[item].synergy_per})
          }
          
          series.data.setAll(this.mappedData)
          series.links.template.setAll({
            tooltipText: "[bold]{sourceId}[/] - [bold]{targetId} ([bold]{value}%)"
          });
          series.nodes.labels.template.setAll({
            maxWidth: '100%',
            oversizedBehavior: "wrap"
          });
    
          
          series.appear(1000, 100);
          root.data.reloadData();
          this.resetSankey = true
        }
      })
    },  
    callfromParent(){
      this.getprojectregions();
    },
    loaddataOnChild() {
      this.listofsynergy_between_variables_data = [];
      apifactory
        .api_synergy_between_variables_get()
        .then((res) => {

          if (res.status != 200) {
            alert(res.message);
          } else {
            this.listofsynergy_between_variables_data = res.data;
            this.loaddataForsynergy_input_list();
          }
        }).catch((e) => {
          console.log('error', e.message)
        })
    },
    loaddataForsynergy_input_list() {
      apifactory
        .api_synergy_between_variables_get_model_data()
        .then((res) => {

          if (res.status != 200) {
            alert(res.message);
          } else {
            this.synergy_input_list = res.data.synergy_input_list;
            this.copiedItems = [...this.synergy_input_list]
            this.loadsaveddata();
            this.drawSankeyDiagram()
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    loadsaveddata() {
      this.itemlistofsavedParamameters = [];
      this.synergy_input_list_selected=[];
      this.savedid = 0;
      apifactory
        .api_synergy_between_variables_save_roi_parameters_getbyid()
        .then((res) => {

          if (res.status != 200) {
            alert(res.message);
          } else {

            let templist=res.data.synergy[0].param;
            this.itemlistofsavedParamameters=templist.split(',');
            this.synergy_input_list_selected=templist.split(',');
            this.savedid = res.data.synergy[0].id;
            this.isLoading = false
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    OnclickSaveAndEdit() {
      this.synergy_input_list = []
      if (this.savedid == 0) {
        this.saveNewData(this.synergy_input_list_selected);
      } else {
        this.UpdateData(this.synergy_input_list_selected, this.savedid);
      }
    },
    saveNewData(varlistofparams) {
      apifactory
        .api_Synergy_Activities_save_roi_parameters_addnew(varlistofparams)
        .then((res) => {

          if (res.status != 200) {
            alert(res.message);
          } else {
            this.reloadData();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    UpdateData(varlistofparams, varrecordid) {
      apifactory
        .api_Synergy_Activities_save_roi_parameters_edit(
          varlistofparams,
          varrecordid
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.reloadData();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    reloadData() {
      this.loaddataOnChild();
    },
    getprojectregions() {
      this.isLoading = true
      this.listofregion = [];
      this.isnation=0;
      apifactory
        .api_get_project_region_list()
        .then((res) => {
          //alert(res);

          if (res.status != 200) {
            alert(res.message);
          } else {
            
            this.isnation=res.data.length;
            if( this.isnation >0)
            {
this.listofregion = res.data.filter(a=>a != "national");
            }
           this.loaddataOnChild();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
  watch: {
    resetSankey () {
      console.log('reset')
    }
  },
  mounted() {
    this.getprojectregions()
    console.log('mounted')
  },
};
</script>
<style>
.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}
.subtable-txt {
  font-size: 15px;
  font-weight: bold;
}
.card-style {
  width: 30%;
}
.card-width {
  margin: 1% 1% 1% 1%;
}
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid black !important
}
<style>
